export default __webpack_public_path__ + "fe5bdde60b9c379188f66e8e7161095e.svg";